import PropTypesUtils from '@utils/propTypes'
import styles from './Body.module.scss'

const Body = ({ children }) => <div className={styles.base}>{children}</div>

Body.propTypes = {
  children: PropTypesUtils.children.isRequired,
}

export default Body
